import angular from 'angular';
import { getTaskRelationFieldTypeLabel } from './addRelationFieldDefinitionDialogCtrl';

angular
  .module('cxSettings')
  .controller('TaskParameterDefinitionsDialogCtrl', [
    'resourceFactorySvc',
    'dialogsSvc',
    'flySvc',
    '$element',
    'close',
    'appUrls',
    '$http',
    'taskTemplateId',
    'ModalService',
    'translateListFilter',
    taskParameterDefinitionsDialogCtrl,
  ]);

function taskParameterDefinitionsDialogCtrl(
  resourceFactorySvc,
  dialogsSvc,
  flySvc,
  $element,
  close,
  appUrls,
  $http,
  taskTemplateId,
  ModalService,
  translateListFilter,
) {
  var vm = this;
  vm.definitions = [];
  vm.taskTemplateId = taskTemplateId;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters, null, error.data.type);
    return '';
  };
  const mapDefinition = definition => {
    if (!definition.relationFieldType) return definition;
    return {
      ...definition,
      relationFieldTypeLabel: getTaskRelationFieldTypeLabel(
        definition.relationFieldType,
        translateListFilter,
        definition.name,
      ),
    };
  };

  $http
    .get(`${appUrls.tasks}/api/TaskParameters/Definitions/${taskTemplateId}`)
    .then(function({ data }) {
      vm.definitions = data.map(mapDefinition);
    }, showError);

  vm.save = function() {
    $element.modal('hide');
    close({ count: vm.definitions.length }, 500);
  };

  vm.cancel = function() {
    $element.modal('hide');
    close({ count: vm.definitions.length }, 500);
  };

  vm.submit = function(definition, value, field) {
    if (field !== 'transferToNextPeriod' && !value) return false;
    if (angular.equals(definition[field], value)) return false;

    var model = angular.copy(definition);
    model[field] = value;

    return $http.put(appUrls.tasks + '/api/TaskParameters/UpdateDefinition', model).then(
      function(result) {
        if (result) {
          flySvc.success('msgConfirmChange');
          return true;
        }
        return '';
      },
      function(error) {
        showError(error);
        return '';
      },
    );
  };

  vm.openDefinitionOptions = parameterDefinition => {
    ModalService.showModal({
      template: require('./taskParameterDefinitionOptionsDialog.html'),
      controller: 'TaskParameterDefinitionOptionsDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        parameterDefinition: parameterDefinition,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(parameterDefinition) {
        if (!parameterDefinition) return;
        var definition = vm.definitions.find(x => x.id === parameterDefinition.id);
        if (!!definition) {
          angular.extend(definition, parameterDefinition);
        }
      });
    });
  };

  const addParameterContinuation = modal => {
    modal.element.modal();
    modal.element.on('hidden.bs.modal', function(e) {
      modal.element.off(e); //Remove event
      modal.element.remove(); //Remove element
    });
    modal.close.then(function(parameterDefinition) {
      if (!parameterDefinition) return;
      vm.definitions.push(mapDefinition(parameterDefinition));
      flySvc.success('SuccessTitle');
    });
  };

  vm.openNewParameterDefinitionDialog = function() {
    ModalService.showModal({
      template: require('./addTaskParameterDefinitionDialog.html'),
      controller: 'AddTaskParameterDefinitionDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        taskTemplateId: taskTemplateId,
      },
    }).then(addParameterContinuation);
  };

  vm.openNewRelationFieldDefinitionDialog = function() {
    ModalService.showModal({
      template: require('./addRelationFieldDefinitionDialog.html'),
      controller: 'AddRelationFieldDefinitionDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        taskTemplateId: taskTemplateId,
        definitions: vm.definitions,
      },
    }).then(addParameterContinuation);
  };

  vm.deleteDefinition = function(id) {
    dialogsSvc.showYesNo('msgConfirmDeleteTitle', 'msgDeleteTaskParameter').then(function() {
      $http
        .delete(`${appUrls.tasks}/api/TaskParameters/DeleteDefinition/${id}`)
        .then(function(result) {
          if (vm.definitions) {
            for (var t = 0; t < vm.definitions.length; t++) {
              if (vm.definitions[t].id === id) {
                vm.definitions.splice(t, 1);
                break;
              }
            }
          }
        }, showError);
    });
  };

  vm.move = function(id, up) {
    if (!id) return false;
    return $http
      .put(appUrls.tasks + '/api/TaskParameters/MoveDefinition', {
        taskTemplateId: taskTemplateId,
        parameterId: id,
        up: !!up,
      })
      .then(
        function({ data }) {
          if (data && data.length) {
            data.forEach(r => {
              var definition = vm.definitions.find(x => x.id === r.id);
              if (!!definition) {
                angular.extend(definition, r);
              }
            });
            flySvc.success('msgConfirmChange');
            return true;
          }
          return '';
        },
        function(error) {
          showError(error);
          return '';
        },
      );
  };
}
